import React from "react";
import styles from "./StaticTable.scss";

export const StaticTable = ({ children }) => {
    return <table className={styles.table}>{children}</table>;
};
